<loading-indicator [show]="!formReady || saving"></loading-indicator>

<div [formGroup]="formData" class="generatedHTMLWindow generatedHTMLForm angularForm" *ngIf="formReady">
  <div class="formHeader">
    <span class="navigateBtn navigate-left" (click)="previous()" *ngIf="showPrevBtn && currentOid > 0">
      <svg-icon title="{{'navigation.previous' | translate | uppercase}}" src='./assets/icons/play.svg'></svg-icon>
    </span>
    <span class="headerTitle">{{ 'projectValuation.reportDetails' | translate }}</span>
    <ng-container *ngIf="formData.controls['ParentId'] as ParentId">
      <ng-container *ngIf="formData.controls['ParentValuationEventName'] as ParentValuationEventName">
        <span class="description" *ngIf="ParentValuationPortfolioName || ParentId > 0">{{ 'projectValuation.childOf' | translate }} ({{ParentValuationEventName}})</span>
      </ng-container>
    </ng-container>
    <span class="navigateBtn navigate-right" (click)="next()" *ngIf="showNextBtn && currentOid > 0">
      <svg-icon title="{{'navigation.next' | translate | uppercase}}" src='./assets/icons/play.svg'></svg-icon>
    </span>
  </div>

  <div class="generatedHTMLRoot">
    <div class="mainSection">
      <div class="section" style="width: 100%">
        <div class="sectionTitleContainer">
          <span class="sectionTitle">{{ 'report.reportInformation' | translate | uppercase}}</span>
        </div>
        <div class="sectionRowContainer">
          <div class="sectionRow">
            <div class="sectionFieldContainer">
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'report.oid' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input formControlName="Oid" kendoTextBox type="number" id="form-r-ID" />
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'report.recordStatusId' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-dropdownlist formControlName="RecordStatusId"
                                      [data]="reflistData.ref_recordstatus"
                                      textField="description"
                                      valueField="oid"
                                      [valuePrimitive]="true"
                                      (valueChange)="datasetStatusUpdated($event)"
                                      id="form-recordStatus">
                  </kendo-dropdownlist>
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'report.propertyName' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="PropertyName" kendoTextBox id="form-propertyName" />
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'report.propertyTypeId' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-dropdownlist formControlName="PropertyTypeId"
                                      [data]="reflistData.ref_property_type_l3"
                                      textField="description"
                                      valueField="oid"
                                      [valuePrimitive]="true"
                                      id="form-propertyType">
                  </kendo-dropdownlist>

                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'report.projectStdId' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-dropdownlist formControlName="ProjectStdId" *ngIf="isNew"
                                      #projectRetriever
                                      [data]="retrieverData.Project"
                                      textField="projectName"
                                      valueField="id"
                                      [valuePrimitive]="true"
                                      [filterable]="true"
                                      (selectionChange)="onProjectSelected($event)"
                                      id="form-pUID-ProjectName">
                  </kendo-dropdownlist>
                  <input type="text" *ngIf="!isNew" formControlName="ProjectStdIdDescription" kendoTextBox id="form-ProjectStdIdDescription" />
                </div>
              </div>
              <div class="field width25percent" *ngIf="formData.controls['LeadingMethodId'] as LeadingMethodId">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'report.leadingMethod' | translate }}</span>
                  <span *ngIf="LeadingMethodId.invalid" class="invalid-asterisk"> *</span>
                </div>
                <div class="fieldContainer" [class.invalid-field]="LeadingMethodId.invalid">
                  <kendo-dropdownlist formControlName="LeadingMethodId"
                                      [data]="reflistData.ref_l3_leading_method"
                                      textField="description"
                                      valueField="oid"
                                      [valuePrimitive]="true"
                                      id="form-leading-method">
                  </kendo-dropdownlist>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'report.propertyId' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-dropdownlist formControlName="PropertyId"
                                      #propertyRetriever
                                      [data]="propertyWithoutReport"
                                      (open)="onOpenPropertyWithoutReport()"
                                      [filterable]="true"
                                      textField="name"
                                      valueField="OID"
                                      [valuePrimitive]="true"
                                      *ngIf="isNew"
                                      id="form-propertyAddressObject-ID">
                  </kendo-dropdownlist>
                  <input type="text" *ngIf="!isNew" formControlName="PropertyIdDescription" kendoTextBox id="form-PropertyIdDescription" />
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'report.valuationProjectId' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-dropdownlist formControlName="ValuationProjectId" *ngIf="isNew"
                                      #portfolioRetriever
                                      [filterable]="true"
                                      [data]="getFilteredValuationPortfolios()"
                                      textField="ValuationPortfolioName"
                                      valueField="id"
                                      [valuePrimitive]="true"
                                      id="form-valuationPortfolio">
                  </kendo-dropdownlist>
                  <input type="text" *ngIf="!isNew" formControlName="ValuationProjectIdDescription" kendoTextBox id="form-ValuationProjectIdDescription" />
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectstd.jjlJobId' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="JllJobId" kendoTextBox id="form-jll-job-id" />
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'report.propertyStreet' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="PropertyStreet" kendoTextBox id="form-street" />
                </div>
              </div>
              <div class="field width25percent" *ngIf="formData.controls['TemplateId'] as TemplateId">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'report.templateDescription' | translate }}</span>
                  <span *ngIf="TemplateId.invalid" class="invalid-asterisk"> *</span>
                </div>
                <div class="fieldContainer" [class.invalid-field]="TemplateId.invalid">
                  <kendo-dropdownlist formControlName="TemplateId"
                                      [data]="filteredAvailableTemplates"
                                      textField="Name"
                                      valueField="Oid"
                                      [valuePrimitive]="true"
                                      id="form-templateLanguage">
                  </kendo-dropdownlist>
                </div>
              </div>
              <div class="field width25percent" *ngIf="formData.controls['TemplateId'] as TemplateId">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'report.languageDefinition' | translate }}</span>
                  <span *ngIf="TemplateId.invalid" class="invalid-asterisk"> *</span>
                </div>
                <div class="fieldContainer" [class.invalid-field]="TemplateId.invalid">
                  <kendo-dropdownlist formControlName="languageDefinitionId"
                                      [data]="availableLanguageDefinitions"
                                      textField="description"
                                      valueField="id"
                                      [valuePrimitive]="true"
                                      (valueChange)="filterTemplatesByLanguage($event)"
                                      id="form-languageDefinition">
                  </kendo-dropdownlist>
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'report.propertyMunicapelDescription' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="PropertyMunicapelDescription" kendoTextBox id="form-municipality" />
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'report.propertyPostcode' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="PropertyPostcode" kendoTextBox id="form-postalCode" />
                </div>
              </div>


              <div class="field width25percent" *ngIf="formData.controls['localCurrencyId'] as localCurrencyId">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'report.localCurrency' | translate }}</span>
                  <span *ngIf="localCurrencyId.invalid" class="invalid-asterisk"> *</span>
                </div>
                <div class="fieldContainer" [class.invalid-field]="localCurrencyId.invalid">
                  <kendo-dropdownlist formControlName="localCurrencyId"
                                      [data]="reflistData.ref_currency_with_code"
                                      textField="description"
                                      valueField="oid"
                                      [valuePrimitive]="true"
                                      id="form-localCurrency">
                  </kendo-dropdownlist>
                </div>
              </div>
              <div class="field width25percent" *ngIf="formData.controls['reportCurrencyId'] as reportCurrencyId">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'report.reportCurrency' | translate }}</span>
                  <span *ngIf="reportCurrencyId.invalid" class="invalid-asterisk"> *</span>
                </div>
                <div class="fieldContainer" [class.invalid-field]="reportCurrencyId.invalid">
                  <kendo-dropdownlist formControlName="reportCurrencyId"
                                      [data]="reflistData.ref_currency_with_code"
                                      textField="description"
                                      valueField="oid"
                                      [valuePrimitive]="true"
                                      id="form-reportCurrency">
                  </kendo-dropdownlist>
                </div>
              </div>

              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'report.propertyRegionDescription' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="PropertyRegionDescription" kendoTextBox id="form-federalState" />
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'report.propertyCountryDescription' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-dropdownlist formControlName="PropertyCountryDescription"
                                      [data]="reflistData.ref_valuation_country"
                                      textField="description"
                                      valueField="oid"
                                      [valuePrimitive]="true"
                                      id="form-country">
                  </kendo-dropdownlist>
                </div>
              </div>

              <div class="field width25percent" *ngIf="formData.controls['localUnitOfLengthId'] as localUnitOfLengthId">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'report.localUnithOfLength' | translate }}</span>
                  <span *ngIf="localUnitOfLengthId.invalid" class="invalid-asterisk"> *</span>
                </div>
                <div class="fieldContainer" [class.invalid-field]="localUnitOfLengthId.invalid">
                  <kendo-dropdownlist formControlName="localUnitOfLengthId"
                                      [data]="reflistData.ref_unit_of_length"
                                      textField="description"
                                      valueField="oid"
                                      [valuePrimitive]="true"
                                      id="form-localUnithOfLength">
                  </kendo-dropdownlist>
                </div>
              </div>

              <div class="field width25percent" *ngIf="formData.controls['reportUnitOfLengthId'] as reportUnitOfLengthId">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'report.reportUnithOfLength' | translate }}</span>
                  <span *ngIf="reportUnitOfLengthId.invalid" class="invalid-asterisk"> *</span>
                </div>
                <div class="fieldContainer" [class.invalid-field]="reportUnitOfLengthId.invalid">
                  <kendo-dropdownlist formControlName="reportUnitOfLengthId"
                                      [data]="reflistData.ref_unit_of_length"
                                      textField="description"
                                      valueField="oid"
                                      [valuePrimitive]="true"
                                      id="form-reportUnithOfLength">
                  </kendo-dropdownlist>
                </div>
              </div>

              <div class="field width25percent" *ngIf="formData.controls['DisplayValuesOverTimeId'] as DisplayValuesOverTimeId">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'report.displayValuesOverTimeId' | translate }}</span>
                  <span *ngIf="DisplayValuesOverTimeId.invalid" class="invalid-asterisk"> *</span>
                </div>
                <div class="fieldContainer" [class.invalid-field]="DisplayValuesOverTimeId.invalid">
                  <kendo-dropdownlist formControlName="DisplayValuesOverTimeId"
                                      [data]="reflistData.ref_l3_display_values_over_time"
                                      textField="description"
                                      valueField="oid"
                                      [valuePrimitive]="true"
                                      id="form-displayValuesOverTime">
                  </kendo-dropdownlist>
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer emptyLabel"></div>
                <div class="fieldContainer emptyField"></div>
              </div>

              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'report.valuerId' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-dropdownlist formControlName="ValuerId"
                                      [data]="retrieverData.User"
                                      textField="userDescription"
                                      valueField="id"
                                      [valuePrimitive]="true"
                                      id="form-valuer">
                  </kendo-dropdownlist>
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'report.reportClientFreeText' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="ReportClientFreeText" kendoTextBox id="form-clientReport" />
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'report.ownerBuId' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-dropdownlist formControlName="OwnerBuId"
                                      [data]="reflistData.config_business_units"
                                      textField="description"
                                      valueField="oid"
                                      [valuePrimitive]="true"
                                      id="form-createdBy">
                  </kendo-dropdownlist>
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'report.modifiedBuId' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-dropdownlist formControlName="ModifiedBuId"
                                      [data]="reflistData.config_business_units"
                                      textField="description"
                                      valueField="oid"
                                      [valuePrimitive]="true"
                                      id="form-createdBy">
                  </kendo-dropdownlist>
                </div>
              </div>

              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'report.valuationDate' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-datepicker formControlName="ValuationDate" [format]="dateFormat" id="form-valuationDate"></kendo-datepicker>
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'report.reportStatus' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-dropdownlist formControlName="StatusId"
                                      [data]="reflistData.ref_report_status"
                                      textField="description"
                                      valueField="oid"
                                      [valuePrimitive]="true"
                                      (valueChanged)="finalizationStatusUpdated($event)"
                                      id="form-status">
                  </kendo-dropdownlist>
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'report.ownerUserId' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-dropdownlist formControlName="OwnerUserId"
                                      [data]="reflistData.config_user"
                                      textField="description"
                                      valueField="oid"
                                      [valuePrimitive]="true"
                                      id="form-createdBy">
                  </kendo-dropdownlist>
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'report.createdDate' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-datepicker formControlName="CreatedDate" [format]="dateFormat" id="form-createdAt"></kendo-datepicker>
                </div>
              </div>

              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'report.inspectionDate' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-datepicker formControlName="inspectionDate" [format]="dateFormat" id="form-inspectionDate"></kendo-datepicker>
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'report.inspectionType' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-dropdownlist formControlName="inspectionTypeId"
                                      [data]="reflistData.ref_inspection_type"
                                      textField="description"
                                      valueField="oid"
                                      [valuePrimitive]="true"
                                      id="form-inspectionType">
                  </kendo-dropdownlist>
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'report.modifiedByUserId' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-dropdownlist formControlName="ModifiedByUserId"
                                      [data]="reflistData.config_user"
                                      textField="description"
                                      valueField="oid"
                                      [valuePrimitive]="true"
                                      id="form-modifiedBy">
                  </kendo-dropdownlist>
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'report.changeDate' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-datepicker formControlName="ChangeDate" [format]="dateFormat" id="form-modifiedAt"></kendo-datepicker>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'report.comment' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="comment" kendoTextBox id="form-comment" />
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'report.clientAssetReferenceNumber' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="ClientAssetReferenceNumber" kendoTextBox id="form-clientAssetReferenceNumber" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="section" style="width: 100%">
        <div class="sectionTitleContainer">
          <span class="sectionTitle">{{ 'report.argusSyncStatus' | translate | uppercase}}</span>
        </div>
        <div class="sectionRowContainer">
          <div class="sectionRow">
            <div class="sectionFieldContainer">
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'report.reportArgusImportLastSyncStatus' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="ReportArgusImportLastSyncStatusDescription" kendoTextBox id="form-ReportArgusImportLastSyncStatusDescription" />
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'report.reportArgusImportLastSyncDate' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-datepicker formControlName="ReportArgusImportLastSyncDate" [format]="dateFormat" id="form-ReportArgusImportLastSyncDate"></kendo-datepicker>
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'report.reportArgusImportLastSyncBy' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="ReportArgusImportLastSyncBy" kendoTextBox id="form-ReportArgusImportLastSyncBy" />
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'report.reportArgusImportPropertyAssetId' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="ReportArgusImportPropertyAssetId" format="n0" [spinners]="false" id="form-ReportArgusImportPropertyAssetId"></kendo-numerictextbox>
                </div>
              </div>
            </div>
          </div>

          <div class="sectionRow">
            <div class="sectionFieldContainer">
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'report.reportArgusImportValuatioDataFromArgus' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="ReportArgusImportValuatioDataFromArgusDescription" kendoTextBox id="form-reportArgusImportValuatioDataFromArgus" />
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'report.reportArgusImportValuatioDataFromArgusLastObtained' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-datepicker formControlName="ReportArgusImportValuatioDataFromArgusLastObtained" [format]="dateFormat" id="form-reportArgusImportValuatioDataFromArgusLastObtained"></kendo-datepicker>
                </div>
              </div>
              <div class="field width50percent">
              </div>
            </div>
          </div>

        </div>
      </div>

    </div>
  </div>
</div>
